export * from './product-inventory-dimension-command.model';
export * from './product-inventory-dimension-view.model';